/* KASED theme — global interactions (vanilla JS, no deps) */
(function () {
  var root = document.documentElement;

  /* ---------- toast ---------- */
  var to = document.getElementById('toast'), tm = document.getElementById('toastMsg'), tt;
  function toast(msg){ if(!to)return; tm.textContent = msg; to.classList.add('show'); clearTimeout(tt); tt = setTimeout(function(){ to.classList.remove('show'); }, 2600); }
  window.kasedToast = toast;

  /* ---------- cart count helper ---------- */
  function refreshCart(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = c.item_count; });
    }).catch(function(){});
  }
  window.kasedRefreshCart = refreshCart;
  refreshCart();

  /* ---------- cosmetic colorway switch (homepage sections) ---------- */
  function setVariantTheme(v){
    if(['pink','black','mono','blush'].indexOf(v) === -1) return;
    document.body.setAttribute('data-variant', v);
    document.querySelectorAll('[data-set]').forEach(function(b){
      b.setAttribute('aria-pressed', b.getAttribute('data-set') === v ? 'true' : 'false');
    });
    document.querySelectorAll('[data-sw-name]').forEach(function(el){
      el.textContent = ({pink:'Hot Pink',black:'Blackout',mono:'Mono',blush:'Blush'})[v];
    });
  }
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-set]');
    if(t){ setVariantTheme(t.getAttribute('data-set')); }
  });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('details.faq > summary').forEach(function(sum){
    var d = sum.parentElement, ans = d.querySelector('.ans');
    sum.addEventListener('click', function(e){
      e.preventDefault();
      if(d.hasAttribute('open')){ ans.style.maxHeight = 0; d.removeAttribute('open'); }
      else { d.setAttribute('open',''); ans.style.maxHeight = ans.scrollHeight + 'px'; }
    });
  });

  /* ---------- scroll reveal ---------- */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {threshold:.12});
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

    var bars = document.getElementById('bars');
    if(bars){
      var bio = new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){
          e.target.querySelectorAll('.fill').forEach(function(f){ f.style.width = f.getAttribute('data-w') + '%'; });
          bio.unobserve(e.target);
        }});
      }, {threshold:.4});
      bio.observe(bars);
    }
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  /* ---------- sticky buy bar (homepage) ---------- */
  var bar = document.getElementById('buybar');
  var sentinel = document.querySelector('[data-buybar-sentinel]');
  if(bar && sentinel && 'IntersectionObserver' in window){
    var sio = new IntersectionObserver(function(es){
      es.forEach(function(e){ bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, {threshold:0});
    sio.observe(sentinel);
  }

  /* ====================================================================
     PRODUCT PAGE — variant selection + AJAX add to cart
     ==================================================================== */
  var pform = document.querySelector('[data-product-form]');
  if(pform){
    var variants = JSON.parse(document.getElementById('product-variants').textContent);
    var selected = {};
    // init from option pills marked pressed
    pform.querySelectorAll('[data-opt-index]').forEach(function(group){
      var idx = group.getAttribute('data-opt-index');
      var active = group.querySelector('[aria-pressed="true"]') || group.querySelector('[data-opt-value]');
      if(active){ selected[idx] = active.getAttribute('data-opt-value'); }
    });

    function colorwayToTheme(val){
      val = (val||'').toLowerCase();
      if(val.indexOf('pink') > -1 && val.indexOf('blush') === -1) return 'pink';
      if(val.indexOf('black') > -1 || val.indexOf('stealth') > -1) return 'black';
      if(val.indexOf('mono') > -1 || val.indexOf('grey') > -1 || val.indexOf('gray') > -1) return 'mono';
      if(val.indexOf('blush') > -1 || val.indexOf('rose') > -1) return 'blush';
      return null;
    }

    function findVariant(){
      return variants.find(function(v){
        return v.options.every(function(opt, i){ return selected[i] === opt; });
      });
    }

    function update(){
      var v = findVariant();
      var idInput = document.getElementById('variant-id');
      var addBtn = pform.querySelector('[data-add-btn]');
      var priceNow = document.querySelector('[data-price-now]');
      if(v){
        idInput.value = v.id;
        if(priceNow) priceNow.textContent = (v.price/100).toLocaleString(undefined,{style:'currency',currency:window.KASED_CURRENCY||'EUR'});
        if(v.available){ addBtn.classList.remove('sold-out'); addBtn.textContent = addBtn.getAttribute('data-label'); }
        else { addBtn.classList.add('sold-out'); addBtn.textContent = 'Sold out'; }
      } else {
        addBtn.classList.add('sold-out'); addBtn.textContent = 'Unavailable';
      }
    }

    pform.querySelectorAll('[data-opt-index]').forEach(function(group){
      var idx = group.getAttribute('data-opt-index');
      group.addEventListener('click', function(e){
        var pill = e.target.closest('[data-opt-value]');
        if(!pill) return;
        e.preventDefault();
        selected[idx] = pill.getAttribute('data-opt-value');
        group.querySelectorAll('[data-opt-value]').forEach(function(p){ p.setAttribute('aria-pressed', p===pill ? 'true':'false'); });
        // drive case color if this option is the colorway
        var theme = colorwayToTheme(pill.getAttribute('data-opt-value'));
        if(theme && group.getAttribute('data-is-color') === 'true'){ document.body.setAttribute('data-variant', theme); }
        update();
      });
    });
    update();

    pform.addEventListener('submit', function(e){
      e.preventDefault();
      var id = document.getElementById('variant-id').value;
      var qty = (document.getElementById('pdp-qty')||{value:1}).value || 1;
      fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items:[{ id: id, quantity: parseInt(qty,10) }] })
      }).then(function(r){ return r.json(); }).then(function(){
        refreshCart();
        toast('Added to cart.');
      }).catch(function(){ window.location.href = '/cart'; });
    });
  }
})();

/* ---------- v2: hero slider ---------- */
(function(){
  var hero = document.querySelector('[data-hero]');
  if(!hero) return;
  var slides = hero.querySelectorAll('[data-slide]');
  if(slides.length < 2) return;
  var dots = hero.querySelectorAll('[data-dots] button');
  var i = 0, timer;
  function go(n){
    slides[i].style.display = 'none';
    if(dots[i]) dots[i].setAttribute('aria-pressed','false');
    i = (n + slides.length) % slides.length;
    slides[i].style.display = '';
    if(dots[i]) dots[i].setAttribute('aria-pressed','true');
  }
  function start(){ timer = setInterval(function(){ go(i+1); }, 6000); }
  function stop(){ clearInterval(timer); }
  dots.forEach(function(d, idx){ d.addEventListener('click', function(){ stop(); go(idx); start(); }); });
  if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){ start(); }
})();

/* ---------- v2: product gallery thumbs ---------- */
(function(){
  var mainImg = document.getElementById('pdp-main-img');
  if(!mainImg) return;
  document.querySelectorAll('.gallery .thumbs button').forEach(function(b){
    b.addEventListener('click', function(){
      mainImg.src = b.getAttribute('data-img');
      document.querySelectorAll('.gallery .thumbs button').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
      b.setAttribute('aria-pressed','true');
    });
  });
})();
